export const WorkdayProjectDatasetsTableConfig = {
  DefaultPageSize: 10,
  DefaultPageNumber: 1,
};
